<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="chap1"><span class="ch2"><b>chapter 2</b></span></p>
<p class="chap2"><b>BOWL SIZES AND FABRICS</b></p>
<p class="fig"><img alt="" src="images/pg10_1.jpg"/></p>
<p class="fig"><img alt="" src="images/pg11_1.jpg"/></p>
<p class="h1"><b>CHOOSING A BOWL</b></p>
<p class="indent">The projects are listed in this book from easiest to most difficult. Bowl 1 is a one-piece cloth bowl. Bowl 2 is a six-piece bowl. Both projects can be sewn with straight seams on a machine.</p>
<p class="indent">Bowl 3, the flower bowl, can be sewn on a machine with a zigzag or decorative stitch or by hand for an easy hand-sewing project.</p>
<p class="indent">Bowl 4 is a Dresden block bowl made from nineteen pieces that can be sewn on a machine.</p>
<p class="indent">In Bowl 5, the single-star bowl, and Bowl 6, the double-star bowl, the center star can be sewn by hand.</p>
<p class="indent">Keep these descriptions in mind when you decide which project to start with. All the patterns in this book are for bowls with a diameter of 16˝ (40.6cm) and a height of 4½˝ (11.4cm). If you’d like to make the bowls smaller, see Chapter 13: Changing the Size of the Bowl.</p>
<p class="h1"><b>CHOOSING FABRICS</b></p>
<p class="indent">You can choose a fabric before or after you choose a bowl project. In general, bold fabrics with high contrast create exciting bowls. The process for selecting fabrics for bowls is very similar to selecting fabrics for a quilt block. The patterns in this book are for bowls made up of six identical units. In some bowls, the units meet in the center; in others, the six units surround the center. So except for Bowl 1, the center of the bowl is the focal point. Keep that in mind when choosing a fabric.</p>
<p class="h2"><b>Nondirectional Fabric</b></p>
<p class="indent">Fabrics with overall designs that do not need to be oriented a certain way work well for these bowls, especially Bowl 1. To make a nondirectional fabric more interesting, consider adding appliqué designs. In this example, I added appliqué red and black circles to highlight the existing pattern on the fabric.</p>
<p class="fig"><img alt="" src="images/pg12_1.jpg"/></p>
<p class="caption">Fabric with nondirectional design</p>
<p class="fig"><img alt="" src="images/pg12_2.jpg"/></p>
<p class="caption">Appliqué added</p>
<p class="indent">You should consider the best way to use the fabric you choose. In this example of a nondirectional floral pattern, decide which flower should be in the center of the bowl to make best use of the pattern. Keep in mind that some parts of the pattern will be lost to the six wedges that form the shape of the bowl.</p>
<p class="fig"><img alt="" src="images/pg12_3.jpg"/></p>
<p class="caption">Fabric used in one-piece cloth bowl</p>
<p class="fig"><img alt="" src="images/pg13_1.jpg"/></p>
<p class="caption">Fabric with nondirectional floral pattern</p>
<p class="fig"><img alt="" src="images/pg13_2.jpg"/></p>
<p class="caption">Fabric used in one-piece cloth bowl</p>
<p class="h2"><b>Directional Fabric</b></p>
<p class="indent">Fabrics with directional designs work great for every bowl except Bowl 1.</p>
<p class="indent">The center circles of Bowl 3 and Bowl 4 are made from one piece of interfacing, so it is best to make each with one piece of fabric. You can leave the fabric as is or add appliqué or decorative stitches. If you choose to leave the fabric as is, try highlighting a single motif from the fabric’s design.</p>
<p class="fig"><img alt="" src="images/pg14_1.jpg"/></p>
<p class="caption">Single flower motif as center circle</p>
<p class="fig"><img alt="" src="images/pg14_2.jpg"/></p>
<p class="caption">Decorative stitches added to center circle</p>
<p class="indent">The centers of Bowls 2, 5, and 6 are pieced, so they can be made interesting by fussy cutting the fabric into a secondary design. See Basic Techniques for All Bowls to learn more about fusing directional fabrics.</p>
<p class="fig"><img alt="" src="images/pg15_1.jpg"/></p>
<p class="caption">Fabric with leaf motif</p>
<p class="fig"><img alt="" src="images/pg15_2.jpg"/></p>
<p class="caption">Stems creating simple motif</p>
<p class="fig"><img alt="" src="images/pg15_3.jpg"/></p>
<p class="caption">Motif creating interesting design for final bowl</p>
<p class="h3"><b><i>Stripes</i></b></p>
<p class="indent">Stripes, running in either direction, can make the center of the bowl very interesting. Even checkered patterns with both vertical and horizontal lines work great.</p>
<p class="fig"><img alt="" src="images/pg16_1.jpg"/></p>
<p class="caption">Fabric with stripes in both directions</p>
<p class="fig"><img alt="" src="images/pg16_2.jpg"/></p>
<p class="caption">Template shape positioned horizontally</p>
<p class="fig"><img alt="" src="images/pg16_3.jpg"/></p>
<p class="caption">Center star with horizontal lines</p>
<p class="fig"><img alt="" src="images/pg16_4.jpg"/></p>
<p class="caption">Template shape positioned vertically</p>
<p class="fig"><img alt="" src="images/pg16_5.jpg"/></p>
<p class="caption">Center star with vertical lines</p>
<p class="h3"><b><i>Graphic Patterns</i></b></p>
<p class="indent">Patterns with very strong contrast can make very interesting centers.</p>
<p class="fig"><img alt="" src="images/pg17_1.jpg"/></p>
<p class="caption">Fabric with graphic pattern</p>
<p class="fig"><img alt="" src="images/pg17_2.jpg"/></p>
<p class="caption">Curved black lines will create secondary pattern in center of bowl</p>
<p class="fig"><img alt="" src="images/pg17_3.jpg"/></p>
<p class="caption">Center star with secondary pattern</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_chapter02.vue?c51dd4e0